/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-12-10 14:31:32
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-07-01 16:20:56
 */
import React, { Component } from 'react'
import './index.css'
import axios from 'axios'
import Template from '../template';

import { connect } from 'react-redux'
import { Table, message } from 'antd';


let columns = [
    {
        title: "权限",
        dataIndex: "roleName",
        key: "roleName"
    },
    {
        title: "权限有无",
        dataIndex: "isHaving",
        key: "isHaving"
    }
]

const dataSource = [
    {
        key: "1",
        roleName: "新闻公告管理",
        isHaving: '否'
    },
    {
        key: "2",
        roleName: "培训资料管理",
        isHaving: '是'
    },
    {
        key: "3",
        roleName: "直播功能",
        isHaving: '否'
    },
    {
        key: "4",
        roleName: "论坛管理权限",
        isHaving: '是'
    },
    {
        key: "5",
        roleName: "生产任务分配（客户端）",
        isHaving: '是'
    },
    {
        key: "6",
        roleName: "打点任务下发（APP）",
        isHaving: '否'
    },
    {
        key: "7",
        roleName: "0-2级原始影像显示",
        isHaving: '是'
    },
    {
        key: "8",
        roleName: "战场显示权限",
        isHaving: '否'
    },
    {
        key: "9",
        roleName: "综合实验管理",
        isHaving: '是'
    },
    {
        key: "10",
        roleName: "检验功能权限",
        isHaving: '是'
    },
]

class MyRole extends Component {

    state = {
        roleList: [],
        userInfo: {},
    }
    componentDidMount() {
        this.getAllUserInfo();
        this.getNowUserInfo();
    }
    //获取所有权限信息列表
    getAllUserInfo = () => {
        axios.get(global.url.sys + `/sys/role/list`
        ).then(res => {
            console.log("getAllUserInfo-----", res.data);
            if (res.data.code === "200") {
                this.setState({ roleList: [...res.data.payload] });
            }
            else {
                message.error("获取用户角色信息失败，请检查网络连接……")
            }
        }).catch((e) => {
            message.error("获取用户角色信息失败，请检查网络连接……")
            console.log(e);
        })
    }
    //获取当前用户信息
    getNowUserInfo = () => {
        const { user } = this.props;
        console.log("user", user);
        axios.get(global.url.sys + `/sys/role/getUserRole?userId=${user.userId}`
        ).then(res => {
            console.log("getAllUserInfo-----", res.data);
            if (res.data.code === "200") {
                this.setState({ userInfo: res.data.payload });
            }
            else {
                message.error("获取用户角色信息失败，请检查网络连接……")
            }
        }).catch((e) => {
            message.error("获取用户角色信息失败，请检查网络连接……")
            console.log(e);
        })
    }

    render() {

        // let data = ''
        // //在获取reducer的时候，里面的值是空的，因此使用了trycatch
        // try {
        //     data = this.props.user.roleInfos[0].name
        // } catch (error) {
        //     console.log(error)
        // }
        const { roleList } = this.state;
        return (
            <Template title="我的权限">
                <div className="usercenter-myrole-content-backpanel">
                    <div className="usercenter-myrole-content-rolename">
                        用户角色权限：
                        {/* <div className="usercenter-myrole-content-roletype">{data}</div> */}
                    </div>
                    {/* <button onClick={this.click}>xxxxx</button> */}
                    {/* <Table pagination={false} scroll className='usercenter-mycoin-coinchange-table' dataSource={dataSource} columns={columns}></Table> */}
                    {roleList.map((e) => {
                        return (
                            <div key={e.roleName} className="usercenter-myrole-content-rolecontent">
                                <div className="usercenter-myrole-content-rolecontent-name">{e.roleName}</div>
                                <div className={`usercenter-myrole-content-rolecontent-ishaving${this.returnIsInNowUserInfo(e) ? "Back" : ""}`}></div>
                            </div>
                        );
                    })}
                </div>
            </Template>
        );
    }

    returnIsInNowUserInfo = (nowRole) => {
        const { userInfo } = this.state;
        let roleList = userInfo.roles;
        let flag = false;
        if (roleList) {
            roleList.map((role) => {
                if (nowRole.roleName === role.roleName)
                    flag = true;
            })
        }
        return flag;
    }
}

const mapState = (state) => ({
    user: state.userReducer.get('user').toJS()
})

export default connect(mapState)(MyRole)
